import React, { useState } from 'react'
import {
  FiSettings,
  FiShoppingCart,
  FiToggleLeft,
  FiToggleRight,
} from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { ILicenseIntegration, IntegrationStatus } from '../../../models/License'
import { theme } from '../../../theme'
import { Color } from '../../ColorPalette'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import { Label, MenuElement } from './index'
import { withRouter } from 'react-router'
import { PopoveredIcon2 } from '../../PopoveredIcon/PopoveredIcon'
import SmartLink from './SmartLink'

function Integration({
  className,
  label,
  data,
  color,
  size = 1,
  link,
  onClick,
  history,
}: IIntegrationProps & IWithSize & any) {
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  // const theme2 = useTheme()
  // const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))

  // const handlePopoverOpen = event => {
  //   event.preventDefault()
  //   event.stopPropagation()
  //   setPopoverAnchor(event.currentTarget)
  // }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   setTimeout(() => {
  //     setPopoverAnchor(target)
  //   }, 50)
  // }

  const goTo = () => {
    if (
      !(
        link.includes('airbnb') &&
        history.location.pathname.includes('airbnb-info')
      )
    ) {
      return
    }
    history.push(link)
  }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      className={`${className}-item-${label}-button`}
      nested={true}
      onClick={goTo}
      // onMouseEnter={isMobile ? undefined : handleMouseEnter}
    >
      <SmartLink onClick={onClick} size={size} to={link} nested={true}>
        <Label size={size}>
          <Flex alignCenter={true} full={true}>
            <Flex alignCenter={true}>
              <Color
                size={size}
                style={{
                  marginLeft: `${7 * size}px`,
                  marginRight: `${9 * size}px`,
                }}
                color={color}
                extraSmall={true}
              />
              <span
                style={{
                  color:
                    data.status !== IntegrationStatus.NotPurchased
                      ? theme.colors.palette.emerald
                      : 'black',
                  fontWeight:
                    data.status !== IntegrationStatus.NotPurchased
                      ? 'bold'
                      : 500,
                }}
              >
                {label}
              </span>
            </Flex>

            <Flex alignCenter={true} full={true} justifyEnd={true}>
              <div
                style={{
                  color:
                    data.status === IntegrationStatus.Active ||
                    data.status === IntegrationStatus.NotPurchased
                      ? theme.colors.palette.emerald
                      : 'black',
                }}
              >
                {data.status === IntegrationStatus.Inactive && (
                  <FiToggleLeft size={18 * size} />
                )}
                {data.status === IntegrationStatus.Active && (
                  <FiToggleRight size={18 * size} />
                )}
                {data.status === IntegrationStatus.NotPurchased && (
                  <FiShoppingCart size={18 * size} />
                )}
                {data.status === IntegrationStatus.NotConfigured && (
                  <FiSettings size={18 * size} />
                )}
                {data.status === IntegrationStatus.NotSupported && (
                  <PopoveredIcon2
                    anchorEl={popoverAnchor}
                    // onOpen={isMobile ? undefined : handlePopoverOpen}
                    onClose={handlePopoverClose}
                  />
                )}
              </div>
            </Flex>
          </Flex>
        </Label>
      </SmartLink>
    </MenuElement>
  )
}

export default withRouter(Integration)

export interface IIntegrationProps {
  className: string
  data: ILicenseIntegration
  label: string
  color: string
  link: string
  onClick: any
}
